/**
 * Marks a product-zone value a human wrote or corrected, rather than an agent.
 *
 * The counterpart to {@link FromRunTag}, and needed for the same reason: an
 * edit is applied to `gap` in place, so without the tag the reviewer's own
 * sentence is indistinguishable from the refiner's — and anyone judging the
 * pipeline by reading the page would be crediting it with work it did not do.
 */
export function EditedTag() {
  return <span className="gr-edited">edited</span>;
}
